import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.41667 2.5C3.80584 2.5 2.5 3.80584 2.5 5.41667V14.1667C2.5 16.0076 3.99238 17.5 5.83333 17.5H15C16.3807 17.5 17.5 16.3807 17.5 15V9.16667C17.5 7.78595 16.3807 6.66667 15 6.66667H14.1667V4.5098C14.1667 3.39982 13.2668 2.5 12.1569 2.5H5.41667ZM12.5 6.66667V4.5098C12.5 4.32029 12.3464 4.16667 12.1569 4.16667H5.41667C4.72631 4.16667 4.16667 4.72631 4.16667 5.41667C4.16667 6.10702 4.72631 6.66667 5.41667 6.66667H12.5ZM12.9167 13.125C13.492 13.125 13.9583 12.6586 13.9583 12.0833C13.9583 11.508 13.492 11.0417 12.9167 11.0417C12.3414 11.0417 11.875 11.508 11.875 12.0833C11.875 12.6586 12.3414 13.125 12.9167 13.125Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }